import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import Loader from './../shared/loader'
import VueElementLoading from 'vue-element-loading'

export default {
	name: 'purchaseOrder',
	components: {
		VueElementLoading,
		DatePicker,
		Loader
	},
	props:['selectedRow'],

	data: function() {
		return {
	
			accordianTab: {
				1: false,
				2: false,
				3: false,
				4: false,
			},
			isLoading2:false,
			expanded: false,
			getDetails:false,
			listnpoData:[],
			coverimage:'',
			listnotinwarded:[],
			outsideproductdata:[],
			drno: '',
			DRerrors: false,
			isDrfound: false,
			listGRCData: [],
			grcDetailModal: false,
			contentVisible:false,
			productid: '',
			listGRCDetails: [],
			//for barcode print
			productarray: [],
			quantity: '',
			showmodal: false,
			isLoading: false,
			isModelLoading: false,
			clientid: '',
			client: '',
			warehouse: '',
			warehouseid: '',
			showSelectClient: false,
			showSelectWarehouse: false,
			clientList: [],
			warehouseList: [],
			merchantList: [],
			listMerchantData: [],
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			toCheckShowRowIndex:'',
			GRCCounts: {},
			closeDRModal : false,
			closeDrObj : {
				 inwardid : '',
				 clientid : '',
				 warehouseid : '',
				 invreferenceid : '',
				 pono : ''

			},
			useremail : '',
			clientview :1,
			hideGRNExcessQtyFlag:false,
            hideGRNExcessQty:0
		}
	},
	beforeCreate: function() {
		this.isLoading = true;
	},
	created: function() {
		// when a page loads,mounted() will be call
	},
	filters: {
		moment: function(date) {
			if (date == '' || date == null) {
				return
			}
			return moment(date).format('DD-MM-YYYY');
		}
	},
	computed: {
		// selects all checkbox's option
		hasParent() {
			if(this.$route.path != '/grclist'){
				return true
			}else{
				return false
			}
			
		  },
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
        this.useremail = userdetail.email;
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.$alertify.error(this.$t('grcList.grcAuthErr')); 
				this.getClientList();
				this.getWarehouseList();
				break;
			case 'client_user':
				this.clientid = userdetail.clientid;
				this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				this.clientview = 0
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		if (this.selectedRow.invreferenceid) {
			this.drno = this.selectedRow.invreferenceid;
			this.clientid = this.selectedRow.clientid;
			this.warehouseid = this.selectedRow.warehouseid;
			this.getSerachGRCOnDR()
		}
	},
	methods: {
		showList() {
			this.$emit("goBackToParent")
		  },
		  myevent(){
          this.isLoading2 = false
		  },
		//Get Purchase Order list
		getWarehouseList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageNo = this.pageCount = 0;

			this.input = ({
				clientid: this.clientid,
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.data && result.data.data.length > 0) {
						this.listWarehouseData = result.data.data;
						var warehouseListArray = [];
						result.data.data.forEach(function(item) {
							warehouseListArray[item.warehouseid] = item.warehousename;
						});
						this.warehouseList = warehouseListArray;
					}
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},

		getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageNo = this.pageCount = 0;
			this.input = ({
				warehouseid: this.warehouseid,
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.data && result.data.data.length > 0) {
						this.listClientData = result.data.data;

						var clientListArray = [];
						result.data.data.forEach(function(item) {
							clientListArray[item.clientid] = item.clientname;
						});

						this.clientList = clientListArray;
					}
				}, error => {
					this.isLoading = false;
					console.error(error);
				});
		},

		clientSelected() {
			this.clientid = this.client;
			this.pageNo = this.pageCount = 0;
			if (this.clientid) {
				this.getMerchantList();
				if (this.warehouseid) {
					this.getInwardMasterData();
				} else {
					this.getWarehouseList();
				}
			}
		},

		warehouseSelected() {
			this.warehouseid = this.warehouse;
			this.pageNo = this.pageCount = 0;
			if (this.warehouseid) {
				if (this.clientid) {
					this.getInwardMasterData();
				} else {
					this.getClientList();
				}
			}
		},

		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantListArray = [];
						result.data.forEach(function(item) {
							merchantListArray[item.merchantid] = item.merchantname;
						});
						this.merchantList = merchantListArray;
					}
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},
		closeDRSave()
		{

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'saveCloseDR',
					'data': {
						'useremail': this.useremail,
						'inwardid' : this.closeDrObj.inwardid,
						'clientid' : this.closeDrObj.clientid,
						'warehouseid' : this.closeDrObj.warehouseid,
						'invreferenceid' : this.closeDrObj.invreferenceid,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success(response.data.msg);
						this.addusermodal = false;
						this.listGRCData = [];
						this.listnpoData = [];
		                this.outsideproductdata = [];
                        this.listnotinwarded = [];
						this.drno = '';
						this.clientid = '';
						document.getElementById('drno').value = '';
					} else if (response.data.errorCode == -1) {
						this.$alertify.error(response.data.msg);
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		closeStatusDRModal()
		{
			 this.closeDRModal = false;
		},

		showDRCloseConfirmation() {

			if (this.closeDrObj.pono === null) {
				this.$alertify.error("DR Cannot Be Closed, As No PO Is Mapped");
				return false;
			}
			else {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');

				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'validateCloseDR',
					'data': {
						'pono': this.closeDrObj.pono,
						'inwardid': this.closeDrObj.inwardid,
						'clientid': this.closeDrObj.clientid,
						'warehouseid': this.closeDrObj.warehouseid,
						'invreferenceid': this.closeDrObj.invreferenceid,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
					.then((response) => {
						if (response.data.errorCode == 0) {
							//this.$alertify.success(response.data.msg);
							this.closeDRModal = true

						} else if (response.data.errorCode == -1) {
							this.$alertify.error(response.data.msg);
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			}

		},

		dateFormat(date) {
			return moment(date).format('YYYY-MM-DD');
		},

		getSerachGRCOnDR() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');


			if (this.clientid == "") {
				this.DRerrors = (this.$t('common.invalidDR'));
				return false;
			}
			if (this.clientid == '') {
				this.ClientErr = (this.$t('srReport.clientError'));  
				return false;
			}

			if (this.warehouseid == '') {
				this.WarehouseErr = (this.$t('common.warehouseError'));
				return false;
			}
			// if (this.$route.query.drno) {
			// 	this.$router.push({
			// 		path: '/GRClist',
			// 		query: {}
			// 	})
			// }
			this.isDrfound = false;
			this.DRerrors = '';

			this.input = ({
				drno: this.drno,
				warehouseid: this.warehouseid,
				clientid: this.clientid
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSerachGRCOnDR',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.getDRpodata()
					if(result.data.result.counts.hideGRNExcessQty!==undefined){
						this.hideGRNExcessQtyFlag=true;
						this.hideGRNExcessQty=result.data.result.counts.hideGRNExcessQty
					}else{
						this.hideGRNExcessQtyFlag=false;
					}
	               
					
					if (result.data.message == "") {
						this.isDrfound = true;
						this.listGRCData = result.data.result.data;
						this.GRCCounts = result.data.result.counts;
					} else {
						this.DRerrors = result.data.message;
					}
					this.isLoading = false;
				}, error => {
					this.isLoading = false;
					console.error(error);
				})
		},
		getDRpodata() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');


			if (this.clientid == "") {
				this.DRerrors = (this.$t('common.invalidDR'));
				return false;
			}
			if (this.clientid == '') {
				this.ClientErr = (this.$t('srReport.clientError'));
				return false;
			}

			if (this.warehouseid == '') {
				this.WarehouseErr = (this.$t('common.warehouseError'));
				return false;
			}
	
			this.isDrfound = false;
			this.DRerrors = '';

			this.input = ({
				invreferenceid: this.drno,
				warehouseid: this.warehouseid,
				clientid: this.clientid
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getDRpodata',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result) {
						this.listnotinwarded=result.data.result.ponotinwarded;
						this.listnpoData=result.data.result.notinpo
						this.outsideproductdata=result.data.result.outsideproduct;
					}
					this.isLoading = false;
				}, error => {
					this.isLoading = false;
					console.error(error);
				})
		},
		getdetails(data) {
			if(data==''){
				this.$alertify.error(this.$t('common.imageErr')); 
                 return false;
			}
			this.getDetails = true;
			this.coverimage=''
			this.ShowImage(data)
        },
		closeDetails() {
			this.getDetails = false
			this.coverimage=''
        },
		ShowImage(imagedata) {
    
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.pageno = 0;
				if (imagedata == null || imagedata == '' || imagedata == undefined) {
					this.$alertify.error(this.$t('common.imageErr'));
					return false;
				}
				this.isLoading2 = true
				this.input = ({
					's3url': imagedata,
				});
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'viewImagebyurl',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				}).then((result) => {
					if (result.data.Status) {
						this.coverimage=result.data.url
					}
					else {
						this.$alertify.error(this.$t('common.imageErr'));
						this.isLoading2=false;
					}
				})
		},
		getClientId() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

           if(this.user_type!='warehouse_user'){
			this.$alertify.error(this.$t('grcList.grcAuthErr'));
             return false;
		   }
			if (this.drno == "") {
				this.DRerrors =   this.$t('grcList.drError');
				return false;
			}
			this.isLoading = true;
			this.input = ({
				'invreferenceid': this.drno,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'searchDR',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})

				.then((result) => {
					this.isLoading = false;
					if (result.data.data.clientid) {
						this.clientid = result.data.data.clientid;
                        this.closeDrObj.inwardid = result.data.data.inwardid;
						this.closeDrObj.clientid = this.clientid;
						this.closeDrObj.warehouseid = result.data.data.warehouseid;
						this.closeDrObj.invreferenceid = this.drno;
						this.closeDrObj.pono = result.data.data.po;
						this.getSerachGRCOnDR();
					} else {
						this.isLoading = false;
						this.clientid = '';
						this.GRCCounts = {}
						this.isDrfound = false
						this.listGRCData = [];
						this.listnpoData = [];
		                this.outsideproductdata = [];
						this.DRerrors =  this.$t('grcList.validDrError');
					}
				});
			this.isLoading = false;
		},
		openGrcDtlModel(itemId) {
			this.isModelLoading = true;
			this.contentVisible=false;
			this.productid = String(itemId.productid);
			this.grcDetailModal = true;
			this.listGRCDetails=[];
			this.getGRCAllDetils();
			this.toCheckShowRowIndex = Number(this.listGRCData.indexOf(itemId))
			for (var i = 0; i < this.listGRCData.length; i++) {
				if ((i != this.toCheckShowRowIndex) || this.listGRCData[i].contentVisible==true) {
					this.listGRCData[i].contentVisible = false
				}
				else{
					this.listGRCData[i].contentVisible = true					
				}
			}
		},
		closeGrcDetailModal() {
			this.grcDetailModal = false;
		},
		getGRCAllDetils() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.DRerrors = "";
			if (this.drno == "") {
				this.DRerrors = this.$t('grcList.drError');
				this.isModelLoading = false;
				return false;
			}
			this.input = ({
				drno: this.drno,
				productid: this.productid,
				warehouseid: this.warehouseid,
				clientid: this.clientid
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getGRCAllDetils',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					this.contentVisible=true;
					if (result.data.message == "") {
						this.listGRCDetails = result.data.result;
					} else {
						//this.DRerrors=result.data.message;
					}
					this.isModelLoading = false;
				}, error => {
					this.isLoading = false;
					console.error(error)
					this.isModelLoading = false;
				})
		},

		// print code start here
		openmodal(data) {
			this.quantity = '';
			document.getElementById('quantity').value = '';
			this.showmodal = true;
			this.quantity = '';
			this.$validator.reset();
			this.errors.clear();
			this.productarray = data;
		},
		closemodal() {
			this.quantity = '';
			this.$validator.reset();
			this.errors.clear();
			this.showmodal = false;
		},
		submitprint() {
			var qty = this.quantity;
			var productid = this.productarray.productid;
			var mrp = this.productarray.mrp
			this.printproduct(qty, productid, mrp)
		},
		printproduct(qty, productid, mrp) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				productid: productid,
				mrp: mrp,
				qty: qty
			});
			axios({
					method: 'POST',
					'url': 'http://localhost:7500/api/printer/printproductqr',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data.msg == "done") {
						this.$alertify.success(this.$t('grcList.printSuccess'));
						this.closemodal();
					} else {
						this.$t('grcList.printFail');
						this.closemodal();
					}
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	},
	resetFlt() {
		this.listMerchantData = [];
		this.listClientData = [];
		this.listWarehouseData = [];
		this.clientid = "";
		this.warehouseid = "";
		this.listGRCDetails = [];
		this.listGRCData = [];
		this.listnpoData = [];
		this.outsideproductdata = [];
	},
	// beforeDestroy() {
	//   console.log("st5");
	// },
	// destroy() {
	//   console.log("st6");
	// },
}



// WEBPACK FOOTER //
// ./src/views/components/GRC/grclist.component.js